import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import UploaderCircleProgress from "./UploaderCircleProgress";
import fileSrc from "./art/file.png";
import xlsx from "./art/xlsx.png";
import pdf from "./art/pdf.png";
export default {
  props: ["items", "files", "required"],
  data: function data() {
    return {
      fileSrc: fileSrc,
      xlsx: xlsx,
      pdf: pdf
    };
  },
  components: {
    "circle-progress": UploaderCircleProgress
  },
  methods: {
    destroy: function destroy(index, file) {
      URL.revokeObjectURL(file);
      this.items.splice(index, 1);
      this.files.splice(index, 1);
      if (this.required) {
        this.$parent.$emit("uploaderContainsFile", false);
      }
      if (!this.$parent.isAllUploading()) this.$parent.$data.uploading = false;
      this.$emit("delete");
    },
    cancelUpload: function cancelUpload(index) {
      this.items[index].source.cancel();
      this.items[index].status = "cancel";
      if (!this.$parent.isAllUploading()) this.$parent.$data.uploading = false;
    },
    isAllNullExceptOne: function isAllNullExceptOne() {
      var result = this.files.reduce(function (total, cur) {
        return Number(Boolean(cur)) + total;
      });
      return result == 1;
    }
  }
};